import { useSelector } from 'react-redux';
import { Entity } from '../../models';
import { selectEntitiesList } from '../../selectors';

export const useEntities = (): Entity[] | null => {
  const entities = useSelector(selectEntitiesList);

  return entities;
};
